import { useContext } from "react";
import { RegistrationDataContext } from "./Context";

export const useRegistrationData = () => {
  const context = useContext(RegistrationDataContext);
  if (!context) {
    throw new Error('useRegistrationData must be used within a RegistrationDataProvider');
  }
  return context;
};